import { apiClient } from '_app'
import { ApiResponse } from 'dtos'
import { NeedsToBeAddedToABundleDto, NeedsToBeAddedToABundleQueryParams } from 'dtos/toDoLists/ohioBuildABoxes'
import { URIQuery } from 'utils'

const baseUrl = (): string => `/api/to-do-lists/ohio-build-a-boxes/needs-to-be-added-to-a-bundle`

export const getNeedsToBeAddedToABundleToDoList = (queryParams: NeedsToBeAddedToABundleQueryParams) =>
  apiClient.get<ApiResponse<NeedsToBeAddedToABundleDto[]>>(baseUrl() + URIQuery(queryParams)).then(res => res.data)
